import { useTranslation } from "react-i18next";
import DividerWithText from "../../../../../components/DividerWithText";
import NotInformation from "../../../../../components/NotInformation";
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import SelectCoffeeShopApp from "../../Functionality/SelectCoffeShopApp";
import SelectCoffeeShopModal from "../../Modal/SelectCoffeeShopModal";
import CoffeeShopCards from "../../SubComponents/CoffeeShopCards";

/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */

const SelectCoffeeShop = () => {
    const { t } = useTranslation();
    const {
        showModal,
        setShowModal,
        cafeterias,
        handleConfirm,
        handleOpen,
        mealtimes,
        meal,
        searchId,
        searchElement,
        setSearchElement,
        option,
        setSearch,
        simpleSearch,
        setSimpleSearch,
        contractorId,
        supplierId,
        handleChange,
        rowsPerPage,
        pagination,
        emptyFields,
        setCafeterias,
        elementRef
    } = SelectCoffeeShopApp();

    return (
        <>
            <SearchSimple
                id={searchId}
                setBodyForExport={() => { }}
                setSearchResults={setCafeterias}
                searchResults={cafeterias}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option} // name of table
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={contractorId}
                supplierId={supplierId}
            />
            <DividerWithText title={t("select_cafeteria")} spacing="py-3" />
            {cafeterias?.content.length > 0 ? (
               <>
                   <CoffeeShopCards
                       data={cafeterias?.content || []}
                       onClick={handleOpen}
                       elementRef={elementRef}/>
                   {pagination()}
               </>
            ) : (
                <NotInformation text={t("no_cafeterias_available")} card={true} />
            )}


            <SelectCoffeeShopModal
                show={showModal}
                onHide={() => setShowModal(false)}
                onConfirm={handleConfirm}
                disabled={!meal.isValidMealTimeModal()}
                mealtimes={mealtimes}
                handleChange={handleChange}
                emptyFields={emptyFields}
            />
        </>
    );
};

export default SelectCoffeeShop;
